import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=5b6741e2&scoped=true&"
import script from "./Settlement.vue?vue&type=script&lang=js&"
export * from "./Settlement.vue?vue&type=script&lang=js&"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=5b6741e2&lang=less&scoped=true&"
import style1 from "./Settlement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6741e2",
  null
  
)

export default component.exports